import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class TailwindComponentsDropdownIndexComponent extends DropdownActivator {
  @tracked dropdownIsOpen = false;

  @action
  toggleDropdown(val) {
    if (val === undefined) this.dropdownIsOpen = !this.dropdownIsOpen;
    else this.dropdownIsOpen = val;
    this.args?.emitDropdownState?.(this.dropdownIsOpen);
  }

  @action
  closeDropdown() {
    if (!this.dropdownIsOpen) return;
    this.dropdownIsOpen = false;
    this.args?.emitDropdownState?.(false);
  }
}
